import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import axios from "axios";
import { LogOut, Package, X } from "lucide-react";
import { STATUS_LABELS } from "@/data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AuthCallback() {
  const processed = useRef(false);
  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .finally(() => { window.location.href = "/"; });
  }, []);
  return <div className="vf-payment-page" data-testid="auth-callback"><div className="vf-spinner" /></div>;
}

export function AccountModal({ open, user, onClose, onLogout }) {
  const [orders, setOrders] = useState(null);
  useEffect(() => {
    if (open) {
      setOrders(null);
      axios.get(`${API}/my/orders`, { withCredentials: true }).then((r) => setOrders(r.data)).catch(() => setOrders([]));
    }
  }, [open]);

  return (
    <AnimatePresence>
      {open && user && (
        <motion.div className="vf-overlay vf-overlay-center" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose} data-testid="account-modal">
          <motion.div className="vf-modal vf-account-modal" initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 24 }} transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }} onClick={(e) => e.stopPropagation()}>
            <button className="vf-modal-close" onClick={onClose} data-testid="close-account-button" aria-label="Fermer"><X size={19} /></button>
            <p className="vf-kicker">Votre compte</p>
            <div className="vf-account-head">
              {user.picture && <img className="vf-avatar" src={user.picture} alt={user.name} referrerPolicy="no-referrer" />}
              <div><h2>{user.name}</h2><p className="vf-account-email">{user.email}</p></div>
            </div>
            <h3 className="vf-account-sub"><Package size={16} /> Mes commandes</h3>
            <div className="vf-account-orders" data-testid="account-orders">
              {orders === null && <p className="vf-account-empty">Chargement…</p>}
              {orders !== null && orders.length === 0 && <p className="vf-account-empty">Aucune commande pour le moment.</p>}
              {orders?.map((o) => (
                <div className="vf-order-row" key={o.id} data-testid={`account-order-${o.id}`}>
                  <div><b>{o.id}</b><span>{(o.items || []).map((i) => `${i.variant_name} × ${i.quantity}`).join(", ")}</span></div>
                  <div className="vf-order-right">
                    <b>{Number(o.total).toFixed(2).replace(".", ",")} €</b>
                    <span className={`vf-order-status s-${o.status}`}>{STATUS_LABELS[o.status] || o.status}</span>
                  </div>
                </div>
              ))}
            </div>
            <button className="vf-cta-alt vf-logout" onClick={onLogout} data-testid="logout-button"><LogOut size={14} /> Se déconnecter</button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
